var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"translucient-dark",attrs:{"x-small":"","color":_vm.approvalColor}},[_vm._v(" "+_vm._s(_vm.$t(("posts.approval.status_label." + (_vm.post.approvalStatus))))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }